
// Click events
$(document).on("click", "#cart-icon-bubble", function (e) {
  e.preventDefault();
  this.cartNotification = document.querySelector('cart-notification');
  this.cartNotification.renderContents();

});


$(document).on('click', 'cart-notification .quantity__button', function (e) {
  const cartNotification = document.querySelector('cart-notification');
  const input = $(this).siblings("input");
  const action = $(this).data('qty_action');
  const variant_id = $(this).closest(".product-in-cart").data("variant_id");
  const item_key = $(this).closest(".product-in-cart").data("item_key");
  let new_quantity;

  if (action == "decrease") {
    new_quantity = parseInt(input.val()) - 1;
  }
  else {
    new_quantity = parseInt(input.val()) + 1;
  }


  if (new_quantity < 1) {
    new_quantity = 1;
  }

  input.val(new_quantity);
  cartNotification.addItemToCart(item_key, new_quantity);

});

$(document).on('click', 'cart-notification .remove-from-cart', function (e) {
  const cartNotification = document.querySelector('cart-notification');
  const item_key = $(this).closest(".product-in-cart").data("item_key");
  const variant_id = $(this).closest(".product-in-cart").data("variant_id");
  $(this).closest(".product-in-cart").remove();
  cartNotification.addItemToCart(item_key, parseInt(0));
});


$(document).on('click', '.add-to-cart-product-btn', function (e) {
  e.preventDefault();
  const cartNotification = document.querySelector('cart-notification');
  const variant_id = $(this).attr('id');
  cartNotification.addItemToCart(variant_id, "add");
});

//Class functions
class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    openOverlay();
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    closeOverlay();
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  addItemToCart(variant_id, qty, func = "", properties = null, qty_amount = 1, sellingPlanId = null) {
    var skip_func = false;


    if (qty_amount == 0) {
      qty_amount = 1;
    }
    const cartNotification = document.querySelector('cart-notification');
    $(".products-in-cart").hide();
    $(".loading.loading_cart_items").show();
    $(".cart_subtotal").hide();

    var prod_data = {
      quantity: qty_amount,
      id: variant_id,
      properties: properties
    };

    if (func == "add_sub") {
      skip_func = true;
      $('.product-form__submit').attr('disabled', 'disabled');
      prod_data = {
        quantity: qty_amount,
        id: variant_id,
        properties: properties,
        selling_plan: sellingPlanId
      };
    }

    if (qty == "add") {
      var params = {
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: prod_data,

        //Default adding item to cart
        success: function (returning) {
          //console.log(returning);
          var this_function = this;
          if (func != "add_sub") {
            //adding normal items to cart
            cartNotification.renderContents(true);

          } else {
            //adding subscriptions to cart
            cartNotification.renderContents(false);
            var subscription_key = returning.key;
            var subscription_choose_cookies_url = '/products/choose-your-own-cookies?subscription=true&lineitem_key=' + subscription_key;
            $('.subscription_upsale_popup .choose_cookies_for_subscription').attr('href', subscription_choose_cookies_url);
            $('.subscription_upsale_popup').css("display", "block");
            $('.pink-overlaybg').css("display", "block");
            $('.product-form__submit').removeAttr('disabled');
          }
          if (func && !skip_func) {
            var params = null;
            window[func](params);
          }

        },
        error: function (XMLHttpRequest, textStatus) {
            //console.log(XMLHttpRequest.responseJSON.description);
            alert(XMLHttpRequest.responseJSON.description);
        }
      };
      jQuery.ajax(params);
    } else {
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        dataType: 'json',
        data: 'updates[' + variant_id + ']=' + qty,


        success: function (returning) {
          var this_function = this;
          cartNotification.renderContents();
          if (func && !skip_func) {
            var params = null;
            window[func](params);
          }

        },
        error: function (XMLHttpRequest, textStatus) {
          console.log(XMLHttpRequest.responseJSON.description);
        }
      };
      jQuery.ajax(params);
    }

  }

  changeItemsInCart(updateData, func = "") {
    const cartNotification = document.querySelector('cart-notification');
    $(".products-in-cart").hide();
    $(".loading.loading_cart_items").show();
    $(".cart_subtotal").hide();
    var params = {
      type: 'POST',
      url: '/cart/update.js',
      dataType: 'json',
      data: {
        updates: updateData
      },


      success: function (returning) {
        var this_function = this;
        cartNotification.renderContents();
        if (func) {
          var params = null;
          window[func](params);
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        console.log(XMLHttpRequest.responseJSON.description);
      }
    };
    jQuery.ajax(params);

  }


  getItemsInCart(func = "") {
    const cartNotification = document.querySelector('cart-notification');
    var params = {
      type: 'POST',
      url: '/cart.js',
      dataType: 'json',

      success: function (returning) {
        var this_function = this;
        //cartNotification.renderContents();
        if (func) {
          var params = null;
          window[func](returning);
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        console.log(XMLHttpRequest.responseJSON.description);
      }
    };
    jQuery.ajax(params);

  }


  renderContents(open_after = true) {
    var this_function = this;
    var params = {
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      beforeSend: function () {
      },

      success: function (data) {
        //RemoveOrderAttributes();
        var items_html = "";




        $('.cart__total__amount').html(data.item_count);
        var cart_subtotal = data.total_price;
        cart_subtotal /= 100;

        $(".cart__subtotal__amount").text(cart_subtotal.toLocaleString("en-US", { style: "currency", currency: "USD" }));


        //each line item
        $.each(data.items, function (o, item) {




          var properites_html = "";
          var item_key = item.key;
          var is_subscription = false;
          var extra_classes = "";
          var has_picked_cookies = false;
          var has_preferred_delivery_date = false;



          if (!$.isEmptyObject(item.selling_plan_allocation)) {
            is_subscription = true;
            extra_classes += "is_subscription "
          }

          //if has properties
          if (!$.isEmptyObject(item.properties)) {
            $.each(item.properties, function (property_name, property_value) {
              if(property_name == "Picked Cookies"){
                has_picked_cookies = true;
              }
            });

            //create wrapping divs
            properites_html += '<div class="properties_wrapper '+ extra_classes +'">';
              properites_html += '<div class="view_details_toggle">► View Details</div>';
              properites_html += '<div class="view_details_content gray-bg">';

              //loop thru each property
              $.each(item.properties, function (property_name, property_value) {
                properites_html += '<div class="item_properties" rel="'+property_name+'">';
                  properites_html += '<span class="prop_name">' + property_name + ': </span>';
                  
                  //rendering property values
                  var is_prop_values_a_list = property_value.includes(',');
                  if(is_prop_values_a_list){
                    properites_html += '<ul>';
                    var prop_values = property_value.split(", ");
                    $.each(prop_values, function (z, prop_value) {
                      properites_html += '<li rel="'+property_value+'" class="prop_value">' + prop_value + '</li>';
                    });
                    properites_html += '</ul>';
                  }else{
                    properites_html += '<span rel="'+property_value+'" class="prop_value">' + property_value + '</span>';
                  }

                  //adding extra content to empty property values
                  if(is_subscription){
                    if(property_name == "Picked Cookies"){
                      properites_html += '<div><a href="/products/choose-your-own-cookies?subscription=true&lineitem_key=' + item_key + '&edit=true">Select Cookies</a></div>';
                    }
                    if(property_name == "Preferred Delivery Date"){
                      if(!property_value){
                        properites_html += '<div><a href="/products/choose-your-own-cookies?subscription=true&lineitem_key=' + item_key + '&edit=true">Pick Delivery Date</a></div>';
                      }
                    }
                  }

                properites_html += '</div>';
              });

              //close wrapping divs
              properites_html += '</div>';
            properites_html += '</div>';
          }

          var item_price = item.price;
          var optimized_image_src = imgURL(item.image, "200x200", "center");

          item_price /= 100;


          $("cart_content .product-in-cart").attr("data-item_key", item.key);
          $("cart_content .product-in-cart").attr("data-variant_id", item.variant_id);
          $("cart_content .product-in-cart").attr("data-product_id", item.product_id);
          $("cart_content .product-in-cart").attr("data-sku", item.sku);
          $("cart_content .prod-img img").attr("src", optimized_image_src);
          $("cart_content .prod-name").text(item.title);
          $("cart_content .prod-url").attr("href", item.url);
          $("cart_content .prod-properties").html(properites_html);
          $("cart_content .prod-quantity input").attr("value", parseInt(item.quantity));

          $("cart_content .prod-price").text(item_price.toLocaleString("en-US", { style: "currency", currency: "USD" }));


          if (item.variant_id == deliveryItemID) {
            //console.log(item.properties);
            var dateRequested = JSON.stringify(item.properties).replaceAll("{", "").replaceAll("}", "").replaceAll('"', '').replaceAll('Date Selected:', '');
            $("cart_content .prod-price").text(dateRequested);
            $("cart_content .prod-properties").html("");
          }


          var this_item_html = $("cart_content").html();
          items_html += this_item_html;



          //---------------getting the compare at price
          //debug.log(item);
          $.getJSON('/products/' + item.handle + '.js', function(product) {
            // Loop through each variant to find the one that matches the cart item
            $.each(product.variants, function(index, variant) {
              if (variant.id == item.variant_id) {
                var compare_at_price = variant.compare_at_price;
                if(!compare_at_price){
                  return false;
                }
                compare_at_price /= 100;
                compare_at_price.toLocaleString("en-US", { style: "currency", currency: "USD" });
                if(!$("#cart-notification .product-in-cart[data-item_key='"+item_key+"']").find(".compare_at_price").length) {
                  $("#cart-notification .product-in-cart[data-item_key='"+item_key+"']").find(".prod-price").parent().append("<div class='compare_at_price' style='text-decoration: line-through;margin-top: -11px;font-weight: bold;font-size: 19px;'>$"+compare_at_price+"</div>");
                }
                return false;
              }
            });
          });
          //---------------getting the compare at price



        });
        var cart_notification_product = "<div id=\"shopify-section-cart-notification-product\" class=\"shopify-section\">" + items_html + "</div>";
        var cart_notification_button = "<div id=\"shopify-section-cart-notification-button\" class=\"shopify-section\">View my cart\n</div>";
        var cart_icon_bubble = "<div id=\"shopify-section-cart-icon-bubble\" class=\"shopify-section\"><svg width=\"30\" height=\"30\" viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M11.25 16.425H20.4763C21.5263 16.32 22.3963 15.5675 22.6525 14.5438L24.3375 9.05375C24.535 8.26375 23.9388 7.5 23.125 7.5H7.5V17.4538C7.5 18.17 8.08 18.75 8.79625 18.75H18.75\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M7.49988 8.75058V5.00058H4.37488\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M21.8752 23.1244V23.1219C21.8702 22.0882 21.0314 21.2494 19.9939 21.2494C18.9602 21.2494 18.1164 22.0882 18.1252 23.1282C18.1264 24.1607 18.9664 24.9994 20.0002 24.9994C21.0352 24.9994 21.8752 24.1594 21.8752 23.1244Z\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M11.8749 23.1244V23.1219C11.8699 22.0882 11.0312 21.2494 9.99369 21.2494C8.95995 21.2494 8.1162 22.0882 8.12495 23.1282C8.1262 24.1607 8.9662 24.9994 9.99995 24.9994C11.0349 24.9994 11.8749 24.1594 11.8749 23.1244Z\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>\n<span class=\"visually-hidden\">Cart</span><div class=\"cart-count-bubble\"><span aria-hidden=\"true\">" + data.item_count + "</span><span class=\"visually-hidden\">64 items</span>\n  </div></div>";

        this_function.getSectionsToRender().forEach((section => {
          var new_sections = {
            "cart-notification-product": cart_notification_product,
            "cart-notification-button": cart_notification_button,
            "cart-icon-bubble": cart_icon_bubble
          }
          document.getElementById(section.id).innerHTML = this_function.getSectionInnerHTML(new_sections[section.id], section.selector);

        }));

        $(".cart_subtotal").show();
        $(".products-in-cart").show();
        $(".loading.loading_cart_items").hide();
        //console.log(data);
      },
      error: function (XMLHttpRequest, textStatus) {
        console.log(XMLHttpRequest);
        //Shopify.onError(XMLHttpRequest, textStatus);
      }
    };
    jQuery.ajax(params);
    this.header?.reveal();

    if (open_after) {
      this.open();
    }

  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product'
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification') && !$(target).hasClass("ui-corner-all") && !$(target).hasClass("ui-icon") && !$(target).parents('.ui-datepicker').length) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);